import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RsaEncryptionService } from './services/rsa-encryption.service';

/**
 * Módulo Core simplificado
 * Solo contiene el servicio de cifrado RSA
 */
@NgModule({ declarations: [], imports: [CommonModule], providers: [
        RsaEncryptionService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule ya está cargado. Importa CoreModule solo en AppModule.');
    }
  }
}
